import React from "react";
import { useEffect, useMemo, useState } from "react";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import { Link, useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from '../../axios/axiosconf';
import { getFechaActual, convertirHoraMilitarA12h } from "../../../resources/Helper";
import { saveAgendaFocusAndNavigate } from "../../../resources/agendaFocusNavigation";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";

const estiloCeldaHover = {
    display: 'inline-block',
    maxWidth: '280px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'bottom',
};

function celdaConHover(valor) {
    const t = valor != null && valor !== '' ? String(valor) : '';
    return <span title={t || undefined} style={estiloCeldaHover}>{t || '—'}</span>;
}

function esBloqueo(item) {
    return item?.bloqueo !== undefined && item?.bloqueo !== null && String(item.bloqueo).trim() !== '';
}

function getBloqueoId(item) {
    if (!esBloqueo(item)) return null;
    const n = parseInt(String(item.bloqueo), 10);
    return Number.isNaN(n) ? null : n;
}

const opcionesPaginacionES = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todas',
};

const estilosTabla = {
    headCells: {
        style: { fontSize: '13px', fontWeight: 600 },
    },
    cells: {
        style: { fontSize: '13px' },
    },
};

function ListaCitasDia() {

    const history = useHistory();
    const [items, setItems] = useState([]);
    const [fechaConsulta] = useState(() => getFechaActual());
    const [agendas, setAgendas] = useState([]);
    const [estadosCita, setEstadosCita] = useState([]);
    const [filtroAgenda, setFiltroAgenda] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [showModalAcciones, setShowModalAcciones] = useState(false);
    const [citaAccion, setCitaAccion] = useState(null);

    const obtenerUsuario = () => JSON.parse(localStorage.getItem('userdata') || '{}');

    useEffect(() => {
        const userdata = obtenerUsuario();
        if (!userdata?.access_token) return;
        const conf = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        const confCitas = {
            ...conf,
            params: { fecha: fechaConsulta }
        };

        Promise.all([
            axios.get('lista-citas-dia', confCitas).catch(() => ({ data: [] })),
            axios.get('/agendas-usuario', conf).catch(() => ({ data: [] })),
            axios.get('/estados-cita', conf).catch(() => ({ data: [] }))
        ])
            .then(([respCitas, respAgendas, respEstados]) => {
                setItems(Array.isArray(respCitas.data) ? respCitas.data : []);
                setAgendas(Array.isArray(respAgendas.data) ? respAgendas.data : []);
                setEstadosCita(Array.isArray(respEstados.data) ? respEstados.data : []);
            })
            .catch(() => {
                setItems([]);
                setAgendas([]);
                setEstadosCita([]);
            });
    }, [fechaConsulta]);

    const itemsFiltrados = useMemo(() => {
        return items.filter((item) => {
            const coincideAgenda = !filtroAgenda || String(item.id_users) === String(filtroAgenda);
            const coincideEstado = !filtroEstado || String(item.id_estado_cita) === String(filtroEstado);
            return coincideAgenda && coincideEstado;
        });
    }, [items, filtroAgenda, filtroEstado]);

    const nombrePaciente = (item) => {
        const partes = [item.primer_nombre, item.segundo_nombre, item.primer_apellido, item.segundo_apellido]
            .filter(Boolean);
        const desdePaciente = partes.join(' ').replace(/\s+/g, ' ').trim();
        if (desdePaciente) return desdePaciente;
        return (item.cita_paciente || '').trim() || '—';
    }

    const irAAgendaDesdeFila = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        if (!item.id_users || !item.fecha_cita || !item.id) return;
        saveAgendaFocusAndNavigate(history, {
            agendaId: item.id_users,
            agendaNombre: item.nombre_agenda,
            fechaCita: item.fecha_cita,
            horaCita: item.hora_cita,
            citaId: item.id,
        });
    };

    const abrirModalAcciones = (item) => {
        setCitaAccion(item);
        setShowModalAcciones(true);
    };

    const cerrarModalAcciones = () => {
        setShowModalAcciones(false);
        setCitaAccion(null);
    };

    const eliminarBloqueo = async (item) => {
        const bloqueoId = getBloqueoId(item);
        if (!bloqueoId) return;

        const confSwal = await Swal.fire({
            icon: 'warning',
            title: 'Eliminar bloqueo',
            text: '¿Deseas eliminar este bloqueo?',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (!confSwal.isConfirmed) return;

        const userdata = obtenerUsuario();
        if (!userdata?.access_token) return;

        try {
            const conf = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                },
                params: {
                    id: bloqueoId
                }
            };
            await axios.delete('/bloqueo', conf);
            setItems((prev) => prev.filter((x) => String(x.bloqueo) !== String(bloqueoId)));
            cerrarModalAcciones();
            Swal.fire({
                icon: 'success',
                title: 'Bloqueo eliminado',
                timer: 1400,
                showConfirmButton: false
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'No fue posible eliminar el bloqueo'
            });
        }
    };

    const getBotones = (item) => {
        return (
            <button
                type="button"
                className="btn btn-sm citas-dia-icon-btn citas-dia-icon-btn--menu"
                title="Opciones"
                aria-label="Opciones"
                onClick={() => abrirModalAcciones(item)}
            >
                <i className="fas fa-ellipsis-h" />
            </button>
        );
    };

    const irAMiAgenda = (e) => {
        e.preventDefault();
        const userdata = obtenerUsuario();
        const agendaFavorita = userdata?.agenda_favorita != null ? String(userdata.agenda_favorita).trim() : '';
        if (!agendaFavorita) {
            Swal.fire({
                icon: 'info',
                title: 'Sin agenda favorita',
                text: 'No tienes agenda configurada como favorita. Puedes configurarla desde tu perfil.'
            });
            return;
        }
        history.push(`/agenda?profesional=${agendaFavorita}`);
    };

    const cols = [
        { name: 'Hora', sortable: false, cell: (row) => celdaConHover(convertirHoraMilitarA12h(row.hora_cita)) },
        { name: 'Paciente', sortable: false, cell: (row) => celdaConHover(esBloqueo(row) ? 'Bloqueo de agenda' : nombrePaciente(row)) },
        { name: 'Duración', sortable: false, cell: (row) => celdaConHover(row.duracion_cita) },
        { name: 'Motivo consulta', sortable: false, cell: (row) => celdaConHover(esBloqueo(row) ? 'Bloqueo de horario' : row.motivo_consulta) },
        { name: 'Agenda', sortable: false, cell: (row) => celdaConHover(row.nombre_agenda) },
        { name: 'Estado', sortable: false, cell: (row) => celdaConHover(esBloqueo(row) ? 'Bloqueo' : row.estado) },
        { name: 'Acciones', cell: (row) => getBotones(row), center: true, width: '110px' },
    ];

    return <div className="hold-transition">
                <Header />
                <Aside activelink="home" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Citas del Día</h1>
                                </div>
                                <div className="col-sm-6 botones-home">
                                    <button type="button" className="btn btn-primary" onClick={irAMiAgenda}>
                                        Mi Agenda <i className="fas fa-calendar-alt" aria-hidden="true" />
                                    </button>
                                    &nbsp;
                                    <Link to="/busqueda-citas" className="btn btn-primary">Buscar citas <i className="fas fa-search" aria-hidden="true" /></Link>
                                    &nbsp;
                                    <Link to="/control-asistencia" className="btn btn-primary">Control asistencia última cita <i className="far fa-calendar-alt" aria-hidden="true" /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <div className="form-group mb-0">
                                        <label htmlFor="filtro-agenda">Agenda</label>
                                        <select
                                            id="filtro-agenda"
                                            className="form-control"
                                            value={filtroAgenda}
                                            onChange={(e) => setFiltroAgenda(e.target.value)}
                                        >
                                            <option value="">Todas</option>
                                            {agendas.map((agenda) => (
                                                <option key={agenda.id} value={agenda.id}>{agenda.nombre}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group mb-0">
                                        <label htmlFor="filtro-estado">Estado de la cita</label>
                                        <select
                                            id="filtro-estado"
                                            className="form-control"
                                            value={filtroEstado}
                                            onChange={(e) => setFiltroEstado(e.target.value)}
                                        >
                                            <option value="">Todos</option>
                                            {estadosCita.map((estado) => (
                                                <option key={estado.id} value={estado.id}>{estado.nombre}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <DataTable
                                columns={cols}
                                data={itemsFiltrados}
                                pagination
                                highlightOnHover
                                customStyles={estilosTabla}
                                paginationComponentOptions={opcionesPaginacionES}
                                noDataComponent={<div className="p-4 text-center text-muted">No hay citas para mostrar</div>}
                                id={'citas-dia'}
                                />
                            
                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} />

                <Modal show={showModalAcciones} onHide={cerrarModalAcciones} centered dialogClassName="citas-dia-actions-modal">
                    <Modal.Header className="citas-dia-actions-modal__header">
                        <Modal.Title className="citas-dia-actions-modal__title">
                            <span className="citas-dia-actions-modal__title-icon">
                                <i className="fas fa-calendar-check"></i>
                            </span>
                            Acciones de la cita
                        </Modal.Title>
                        <button type="button" className="citas-dia-actions-modal__close" onClick={cerrarModalAcciones}>
                            <i className="fas fa-times"></i>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="citas-dia-actions-modal__body">
                        {citaAccion && (
                        esBloqueo(citaAccion) ? (
                            <>
                                <div className="citas-dia-actions-modal__cita">
                                    <span className="citas-dia-actions-modal__avatar">
                                        <i className="fas fa-ban"></i>
                                    </span>
                                    <div>
                                        <div className="citas-dia-actions-modal__cita-name">Bloqueo de agenda</div>
                                        <div className="citas-dia-actions-modal__cita-meta">
                                            {convertirHoraMilitarA12h(citaAccion.hora_cita)} · {citaAccion.nombre_agenda || 'Sin agenda'}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-column" style={{ gap: '9px' }}>
                                    {Boolean(citaAccion.id_users && citaAccion.fecha_cita && citaAccion.id) && (
                                        <button
                                            type="button"
                                            className="btn citas-dia-modal-action"
                                            onClick={(e) => {
                                                irAAgendaDesdeFila(e, citaAccion);
                                                cerrarModalAcciones();
                                            }}
                                        >
                                            <i className="far fa-calendar-alt mr-2"></i>
                                            Ir a agenda
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="btn citas-dia-modal-action"
                                        onClick={() => eliminarBloqueo(citaAccion)}
                                    >
                                        <i className="fas fa-trash-alt mr-2"></i>
                                        Eliminar bloqueo
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="citas-dia-actions-modal__cita">
                                    <span className="citas-dia-actions-modal__avatar">
                                        {(nombrePaciente(citaAccion).trim().charAt(0) || 'C').toUpperCase()}
                                    </span>
                                    <div>
                                        <div className="citas-dia-actions-modal__cita-name">{nombrePaciente(citaAccion)}</div>
                                        <div className="citas-dia-actions-modal__cita-meta">
                                            {convertirHoraMilitarA12h(citaAccion.hora_cita)} · {citaAccion.nombre_agenda || 'Sin agenda'}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex flex-column" style={{ gap: '9px' }}>
                                    {Boolean(citaAccion.id_users && citaAccion.fecha_cita && citaAccion.id) && (
                                        <button
                                            type="button"
                                            className="btn citas-dia-modal-action"
                                            onClick={(e) => {
                                                irAAgendaDesdeFila(e, citaAccion);
                                                cerrarModalAcciones();
                                            }}
                                        >
                                            <i className="far fa-calendar-alt mr-2"></i>
                                            Ir a agenda
                                        </button>
                                    )}
                                    {!citaAccion.id_paciente ? (
                                        <button type="button" className="btn citas-dia-modal-action disabled" disabled>
                                            <i className="far fa-id-card mr-2"></i>
                                            Sin ficha paciente
                                        </button>
                                    ) : String(citaAccion.estado_paciente) === '1' ? (
                                        <Link
                                            to={'/atender-paciente?id=' + citaAccion.id_paciente}
                                            className="btn citas-dia-modal-action"
                                            onClick={cerrarModalAcciones}
                                        >
                                            <i className="fas fa-user-md mr-2"></i>
                                            Atender
                                        </Link>
                                    ) : (
                                        <Link
                                            to={'/editar-paciente?id=' + citaAccion.id_paciente}
                                            className="btn citas-dia-modal-action"
                                            onClick={cerrarModalAcciones}
                                        >
                                            <i className="far fa-edit mr-2"></i>
                                            Completar anamnesis
                                        </Link>
                                    )}
                                </div>
                            </>
                        )
                        )}
                    </Modal.Body>
                </Modal>

                <style>{`
                    .citas-dia-icon-btn {
                        border: 1px solid transparent;
                        border-radius: 10px;
                        width: 31px;
                        height: 31px;
                        padding: 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        transition: all .15s ease;
                    }
                    .citas-dia-icon-btn--menu {
                        background: rgba(50, 58, 69, 0.1);
                        border-color: rgba(50, 58, 69, 0.18);
                        color: #2f3945;
                    }
                    .citas-dia-icon-btn--menu:hover {
                        background: rgba(50, 58, 69, 0.16);
                        color: #202830;
                        transform: translateY(-1px);
                    }
                    .citas-dia-actions-modal .modal-content {
                        border: none;
                        border-radius: 14px;
                        box-shadow: 0 18px 40px rgba(20, 33, 48, 0.28);
                        overflow: hidden;
                    }
                    .citas-dia-actions-modal__header {
                        border-bottom: 1px solid #edf2f7;
                        padding: 12px 14px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .citas-dia-actions-modal__title {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 1.03rem;
                        font-weight: 700;
                        color: #2b3440;
                    }
                    .citas-dia-actions-modal__title-icon {
                        width: 28px;
                        height: 28px;
                        border-radius: 8px;
                        background: rgba(23, 162, 184, 0.13);
                        color: #148495;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.88rem;
                    }
                    .citas-dia-actions-modal__close {
                        border: 0;
                        background: rgba(50, 58, 69, 0.08);
                        color: #4b5663;
                        width: 30px;
                        height: 30px;
                        border-radius: 999px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .citas-dia-actions-modal__body { padding: 14px; }
                    .citas-dia-actions-modal__cita {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 12px;
                        padding: 10px;
                        border: 1px solid #edf2f7;
                        border-radius: 11px;
                        background: #fafcfe;
                    }
                    .citas-dia-actions-modal__avatar {
                        width: 34px;
                        height: 34px;
                        border-radius: 50%;
                        background: rgba(23, 162, 184, 0.16);
                        color: #147f90;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 700;
                    }
                    .citas-dia-actions-modal__cita-name {
                        font-size: 0.9rem;
                        font-weight: 700;
                        color: #2e3742;
                        line-height: 1.2;
                    }
                    .citas-dia-actions-modal__cita-meta {
                        font-size: 0.76rem;
                        color: #6f7d8b;
                        margin-top: 2px;
                    }
                    .citas-dia-modal-action {
                        border-radius: 12px;
                        font-weight: 700;
                        text-align: left;
                        border: 1px solid rgba(50, 58, 69, 0.08);
                        min-height: 42px;
                        transition: all .16s ease;
                        background: rgba(50, 58, 69, 0.04);
                        color: #3f4a56;
                    }
                    .citas-dia-modal-action:hover {
                        transform: translateY(-1px);
                        background: rgba(50, 58, 69, 0.08);
                        color: #28313a;
                    }
                `}</style>
            </div>
}
export default ListaCitasDia;
